import React from 'react';
import Faqs from '../Shared/Faq';

const ViewFaq = (props) => <Faqs faqs={props.faqs || []} />;

export default ViewFaq;
